import { ValidationError } from '../../types';
import styles from './ErrorText.module.css';

type ErrorTextProps = {
  error?: ValidationError | null;
  text?: string;
  variant?: 'form';
  spacing?: 'bottom';
  className?: string;
};

const ErrorText = ({ error, text, variant, spacing, className }: ErrorTextProps) => {
  if (!error && !text) {
    return null;
  }

  const classes = [
    styles.error,
    variant === 'form' ? styles.form : undefined,
    spacing === 'bottom' ? styles.spacingBottom : undefined,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <p className={classes}>
      {text || error?.message}
    </p>
  );
};

export default ErrorText;
